// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"9f4a5cb5","427":"1ad1f84e","487":"76a6e128","577":"90a9f6c4","636":"080b987f","678":"535ea407","729":"3c37033c"}[chunkId] + ".chunk.css";
};